<template>
  <div class="wrapper">
    <parallax
      :style="headerStyle"
      class="section page-header header-filter"
    ></parallax>
    <div class="main main-raised-top">
      <div class="section profile-content">
        <div class="container">
          <div class="profile-tabs">
            <tabs
              :tab-icon="['cloud']"
              :tab-name="['平台解决方案']"
              color-button="success"
              nav-pills-icons
              plain
            >
              <!-- here you can add your content for tab-content -->
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <!--
                  <div class="md-layout-item ml-auto">
                    <img :src="tabPane1[0].image" class="rounded" />
                    <img :src="tabPane1[0].image" class="rounded" />
                    </div>

                    <div class="md-layout-item ml-auto">
                    <img :src="tabPane1[0].image" class="rounded" />
                    <img :src="tabPane1[0].image" class="rounded" />
                    <img :src="tabPane1[0].image" class="rounded" />
                    </div>




                  -->

                  <h4>升级维护中</h4>
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";

export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bigdata.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
